import { IScoresInformationTableData } from "Interfaces/Job";
import { deepFreeze } from "../components/helpers/miscellaneous";
import { SurveyStates as SurveyStatesEnum } from "./types/SurveyStates";

// Survey Related Variables

export const PSYCHOMETRIC_MIN_ACCEPTABLE_PAGE_TIME = 1.5;
export const TASK_MIN_ACCEPTABLE_PAGE_TIME = 4;
export const SURVEYJS_URL =
  "https://api.surveyjs.io/public/Survey/getSurvey?surveyId=";

/**
 * * Pre-authentication list
 * ! Do not use this initialize survey data of the user.
 * ! Inaccurate. Needs to be reviewed.
 */
export const SurveyList: {
  [x: string]: {
    title: string;
    description: string;
    estimatedTime: string;
    surveyState: SurveyStatesEnum;
    maxSurveyCompensation: number;
    earnedCompensation: number;
    unlockAt: string;
  };
} = deepFreeze({
  personality: {
    title: "Personality Survey",
    description: "Take a personality and aptitude test",
    estimatedTime: "30 min",
    surveyState: "Unlocked",
    maxSurveyCompensation: 20,
    earnedCompensation: 0,
    completeSms: 0,
    earnedSmsAmount: 0,
    totalSms: 3,
    unlockAt: "28 days",
  },
  followUp1: {
    title: "Follow-Up 1",
    description: "Answer questions about your job search",
    estimatedTime: "15 min",
    surveyState: SurveyStatesEnum.LOCKED,
    maxSurveyCompensation: 25,
    earnedCompensation: 0,
    unlockAt: "28 days",
    completeSms: 0,
    earnedSmsAmount: 0,
    totalSms: 3,
  },
  followUp2: {
    title: "Follow-Up 2",
    description: "Answer questions about your job search",
    estimatedTime: "15 min",
    surveyState: SurveyStatesEnum.LOCKED,
    maxSurveyCompensation: 35,
    earnedCompensation: 0,
    unlockAt: "119 days",
    completeSms: 0,
    earnedSmsAmount: 0,
    totalSms: 5,
  },
  // followUp3: {
  //   title: "Follow-Up 3",
  //   description: "Answer questions about your job search",
  //   estimatedTime: "15 min",
  //   surveyState: SurveyStatesEnum.LOCKED,
  //   maxSurveyCompensation: 24,
  //   earnedCompensation: 0,
  //   unlockAt: "161 days",
  //   completeSms: 0,
  //   earnedSmsAmount: 0,
  //   totalSms: 4,
  // },
});

export const SurveyRoutes = {
  elgiblity: "/survey/eligiblity",
  personality: "/survey/personality",
  followUp1: "/survey/follow-up-1",
  followUp2: "/survey/follow-up-2",
  followUp3: "/survey/follow-up-3",
};

export const sectorDict = [
  "Other",
  "Cashier",
  "Childcare",
  "Cook",
  "Customer Service",
  "Healthcare",
  "Receptionist",
  "Sales Agent",
  "Waiter",
  "Warehouse",
];
export const scoresInformationTableData: IScoresInformationTableData[] = [
  {
    occupation: "First Occupation",
    score: "First Score",
  },
  {
    occupation: "Second Occupation",
    score: "Second Score",
  },
  {
    occupation: "Third Occupation",
    score: "Third Score",
  },
  {
    occupation: "Fourth Occupation",
    score: "Fourth Score",
  },
  {
    occupation: "Fifth Occupation",
    score: "Fifth Score",
  },
  {
    occupation: "Sixth Occupation",
    score: "Sixth Score",
  },
];

// eport const groups = ["T1", "T2", "T3", "T4"]
export const aiScoresGroup: Readonly<string[]> = ["T2", "T3"];
export const preferenceScoreGroup: Readonly<string[]> = ["T1", "T3"];

export const pathsForFilters = {
  jobSearch: "/jobs/search",
  savedJobs: "/jobs/saved",
};

export const SurveyAmounts = {
  personalitySurvey: 20,
  followUp1Survey: 16,
  followUp2Survey: 22,
  followUp3Survey: 22,
};

export const maxCompensation = 80;

export const pageTitles = {
  home: "Helping Job Seekers",
  eligibility: "Eligiblity Survey | Helping Job Seekers",
  personality: "Personality Survey | Helping Job Seekers",
  FolllowUp1: "Follow Up 1 Survey | Helping Job Seekers",
  FollowUp2: "Follow Up 2 Survey | Helping Job Seekers",
  FollowUp3: "Follow Up 3 Survey | Helping Job Seekers",
  JobSearch: "Job Search | Helping Job Seekers",
  SavedJob: "Saved Jobs | Helping Job Seekers",
  AppliedJob: "Applied Jobs | Helping Job Seekers",
  About: "About | Helping Job Seekers",
};

// export const datePostedFilter = {
//   7: "7 Days",
//   14: "14 Days",
//   30: "30 Days",
// };

export const datePostedFilter = [7, 14, 36500];

export const SlideMarkValues: readonly number[] = [1, 50, 99];
export const defaultPreferenceScore = 5;

export const distances: readonly string[] = [
  "5 mi",
  "10 mi",
  "20 mi",
  "50 mi",
  "100 mi",
  // "Remote",
];

export const status = [
  "Save for later",
  "Not interested",
  "Applied - Have not heard back",
  "Applied - Scheduled interview",
  "Applied - Received offer!",
  "Applied - Rejected",
];
